import { FC, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import { AppLoader } from '@components/Core/AppLoader/AppLoader';
import { CustomRoute } from '@components/Core/CustomRoute/CustomRoute';
import { Navbar } from '@components/Core/Navbar/Navbar';
import { CustomAlert } from '@components/Core/CustomAlert/CustomAlert';
import { CountryCodeSelect } from '@components/Core/CountryCodeSelect';
import { initAppleAuthService } from '@services/appleAuthService';

const App: FC = () => {
  const {
    mainStore: { globalLoading },
    alertStore: { show },
    profileStore: { userRoutes },
  } = useStore();

  useEffect(() => {
    initAppleAuthService();
  }, []);

  return (
    <BrowserRouter>
      {/* <ServerChecker> */}
      <Routes>
        {userRoutes.map(({ path, disableNavbar, component, isPrivate }, key) => (
          <Route
            key={path + key}
            path={path}
            element={
              <>
                {globalLoading ? (
                  <AppLoader />
                ) : (
                  <CustomRoute isPrivate={isPrivate}>
                    <div className="overflow-hidden flex font-[Geologica] text-basic-text default-text">
                      {disableNavbar ? null : <Navbar />}
                      <div
                        style={{
                          width: '100%',
                          height: '100vh',
                          // overflow: 'auto',
                        }}
                      >
                        {component}
                      </div>
                    </div>
                    {/* {open ? <PopUp /> : null} */}
                    {show ? <CustomAlert /> : null}
                    <CountryCodeSelect />
                  </CustomRoute>
                )}
              </>
            }
          />
        ))}
      </Routes>
      {/* </ServerChecker> */}
    </BrowserRouter>
  );
};

export default observer(App);
